import { PayloadAction } from '@reduxjs/toolkit';
import { WritableDraft } from 'immer';
import ShippingSearchState, { ShippingLookaheadKeys } from './types';

export const resetShippingSearchReducer = (
  state: WritableDraft<ShippingSearchState>
) => {
  state.lookAheadOption = '';
};

export const setShippingLookAheadKeyReducer = (
  state: WritableDraft<ShippingSearchState>,
  action: PayloadAction<string>
) => {
  const clearValue = action.payload !== state.lookAheadOptionType;
  state.lookAheadOptionType = action.payload as ShippingLookaheadKeys;

  if (clearValue) {
    state.lookAheadOption = '';
  }
};

export const setShippingLookAheadOptionReducer = (
  state: WritableDraft<ShippingSearchState>,
  action: PayloadAction<{
    optionType: string;
    optionValue: string;
  }>
) => {
  state.lookAheadOptionType = action.payload
    .optionType as ShippingLookaheadKeys;
  state.lookAheadOption = action.payload.optionValue;
};
